import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
    AangifteSchenkbelasting,
    APV,
    BokkzSbLogic,
    Effecten,
    GiftTaxEntity,
    NotarieleAkte,
    OmschrijvingEnBedrag,
    OndernemingSB,
    OnroerendeZaakSB,
    PU,
    RoerendeZaak,
    SbBerekening,
    Schenking,
    SchenkingOpPapier,
    SchenkingRelatieBegiftigdeMetSchenker,
    Vrijstellingen,
    Vruchtgebruik
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {BokkzAlgDataService, BokkzSbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {NgIf} from "@angular/common";
import {Subscription} from "rxjs";
import {SharedUiTooltipModule} from "@snelstart/ui-tooltip";
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-vrijstellingen',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        NgIf,
        SharedUiTooltipModule,
        SharedUiAlertModule
    ],
    templateUrl: './vrijstellingen.component.html',
    styleUrl: './vrijstellingen.component.css'
})
export class VrijstellingenComponent implements OnInit, OnDestroy {

    @Input() public id!: string;
    private giftTaxEntitySubscription: Subscription | undefined;
    private sbBerekeningSubscription: Subscription | undefined;
    public giftTaxEntity = {} as GiftTaxEntity;
    public sbAangifte = {} as AangifteSchenkbelasting;
    public sbBerekening = {} as SbBerekening;
    public schenkingFg = {} as FormGroup;
    public sbBerekeningFg = {} as FormGroup;
    public vrijstellingenFg = {} as FormGroup;
    public verhoogdeVrijstellingToegepast = false;
    public overigeVrijstellingToegepast = false;
    public studieBedragTeLaag = false;
    public isKindEnJongerDan40Result = false;

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Ja"},
        {value: false, label: "Nee"},
    ];

    constructor(
        public algDataService: BokkzAlgDataService,
        public dataService: BokkzSbDataService,
        public sbService: BokkzSbLogic,
        private fb: FormBuilder) {
        this.schenkingFg = this.fb.group<Schenking>({
            datumSchenking: null as unknown as Date,
            relatieBegiftigdeMetSchenker: null as unknown as SchenkingRelatieBegiftigdeMetSchenker,
            herroepelijkeSchenking: null as unknown as boolean,
            schenkerBetaaltDeSchenkbelasting: null as unknown as boolean,
            uitbreidingBegripSchenker: null as unknown as boolean,
            contanten: null as unknown as OmschrijvingEnBedrag,
            effecten: null as unknown as Effecten,
            onroerendeZaken: null as unknown as OnroerendeZaakSB,
            ondernemingen: null as unknown as OndernemingSB,
            apv: null as unknown as APV,
            periodiekeUitkering: null as unknown as PU,
            roerendeZaak: null as unknown as RoerendeZaak,
            schuldigerkenning: null as unknown as SchenkingOpPapier,
            kwijtscheldingSchuld: null as unknown as OmschrijvingEnBedrag,
            vruchtgebruik: null as unknown as Vruchtgebruik,
            overige: null as unknown as OmschrijvingEnBedrag,
            vrijstellingen: null as unknown as Vrijstellingen,
            notarieleAkte: null as unknown as NotarieleAkte,
            belastingBetaaldInAnderLand: null as unknown as number,
            landCodeBetaaldInAnderLand: null as unknown as string,
        })
        this.sbBerekeningFg = this.fb.group<SbBerekening>({
            totaalBedragContanten: null as unknown as number,
            totaalBedragEffecten: null as unknown as number,
            totaleWaardeGeschonkenOnroerendeZaken: null as unknown as number,
            totaalGeschonkenOndernemingsVermogen: null as unknown as number,
            totaalVrijgesteldOndernemingsVermogen: null as unknown as number,
            totaleWaardeGeschonkenApv: null as unknown as number,
            totaleWaardeGeschonkenPu: null as unknown as number,
            totaleWaardeGeschonkenRoerendeZaken: null as unknown as number,
            totaleWaardeSchuldigErkenning: null as unknown as number,
            totaleWaardeKwijtscheldingen: null as unknown as number,
            totaleWaardeVruchtgebruik: null as unknown as number,
            totaleWaardeOverigeSchenkingen: null as unknown as number,
            totaleSchenking: null as unknown as number,
            totaleBasisVrijstellingen: null as unknown as number,
            totaleVerhoogdeVrijstellingen: null as unknown as number,
            totalOverigeVrijstellingen: null as unknown as number,
            totaleVrijstellingen: null as unknown as number,
            eerderGebruikteVrijstellingen: null as unknown as number,
            benutteVrijstellingen: null as unknown as number,
            totaleVoorwaardelijkeVrijstelling: null as unknown as number,
            totaleBelastbareSchenking: null as unknown as number,
            grondslagEersteSchijf: null as unknown as number,
            grondslagTweedeSchijf: null as unknown as number,
            tariefEersteSchijf: null as unknown as number,
            tariefTweedeSchijf: null as unknown as number,
            belastingEersteSchijf: null as unknown as number,
            belastingTweedeSchijf: null as unknown as number,
            verhogingEersteSchijfVanwegeBrutering: null as unknown as number,
            verhogingTweedeSchijfVanwegeBrutering: null as unknown as number,
            totaalBelastingEersteSchijf: null as unknown as number,
            totaalBelastingTweedeSchijf: null as unknown as number,
            grondslagConserverendeAanslag: null as unknown as number,
            nvt: null as unknown as string
        })
        this.vrijstellingenFg = this.fb.group<Vrijstellingen>({
            eenmaligVerhoogdeVrijstelling: false,
            eenmaligVerhoogdeVrijstellingEigenWoning: false,
            bedragAlBetaaldEigenWoning: null as unknown as number,
            bedragNogTeBestedenEigenWoning: null as unknown as number,
            verhoogdeVrijstellingStudie: false,
            bedragAlBetaaldDureStudie: null as unknown as number,
            bedragNogTeBestedenDureStudie: null as unknown as number,
            vrijstellingSchuldenaar: false,
            vrijstellingNatuurlijkeVerbintenis: false,
            vrijstellingAnbiOfSbbi: false,
            vrijstellingSchenkingDoorKoning: false,
            vrijstellingSchenkingDoorStaat: false,
            vrijstellingSchenkingBelastInIB: false,
            vrijstellingSchenkingAanNabestaandeWerknemer: false,
            vrijstellingOverig: null as unknown as string,
            alGebruikteBasisvrijstelling: null as unknown as number,
            alGebruikteEenmaligeVerhoogdeVrijstelling: null as unknown as number,
            alGebruikteVrijstellingDureStudie: null as unknown as number,
            vrijstellingBedrijfsvermogenVanToepassing: "Nee",
            basisVrijstellingVanToepassing: "Ja",
            vrijstellingBedrijfsvermogen: null as unknown as number,
        })
    }

    ngOnInit(): void {
        this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value) => {
            this.giftTaxEntity = value;
            const aangifte = value.aangifte
            if (aangifte) {
                this.sbAangifte = aangifte;
                if (aangifte.schenking) {
                    this.schenkingFg.patchValue(aangifte.schenking[0], {emitEvent: false})
                    if (aangifte.schenking[0].vrijstellingen) {
                        this.vrijstellingenFg.patchValue(aangifte.schenking[0].vrijstellingen, {emitEvent: false})
                    }
                }
            }
        })
        this.sbBerekeningSubscription = this.dataService.sbBerekening.subscribe((value) => {
            this.sbBerekeningFg.patchValue(value, {emitEvent: false})
            this.vrijstellingenFg.patchValue({vrijstellingBedrijfsvermogenVanToepassing: "Ja"}, {emitEvent: false})
            this.vrijstellingenFg.patchValue({vrijstellingBedrijfsvermogen: value.totaalVrijgesteldOndernemingsVermogen}, {emitEvent: false})
        })
        this.vrijstellingenFg.get('eenmaligVerhoogdeVrijstelling')?.valueChanges.subscribe(() => {
            this.recalculateBerekeningVerhoogd();
        });

        const veldenOmTeVolgen = [
            'eenmaligVerhoogdeVrijstelling',
            'verhoogdeVrijstellingStudie',
            'vrijstellingSchuldenaar',
            'vrijstellingNatuurlijkeVerbintenis',
            'vrijstellingAnbiOfSbbi',
            'vrijstellingSchenkingDoorKoning',
            'vrijstellingSchenkingDoorStaat',
            'vrijstellingSchenkingBelastInIB',
            'vrijstellingSchenkingAanNabestaandeWerknemer',
            'vrijstellingOverig'
        ];
        veldenOmTeVolgen.forEach(veld => {
            this.vrijstellingenFg.get(veld)?.valueChanges.subscribe(() => {
                this.recalculateBerekeningOverig();
            });
        });
        this.toepassenVerhoogdeVrijstelling();
        this.toepassenOverigeVrijstelling();
        this.vrijstellingenFg.valueChanges.subscribe(() => {
            this.toepassenVerhoogdeVrijstelling();
            this.toepassenOverigeVrijstelling();
        });

        const initValues = this.vrijstellingenFg.value;
        const bedrag1 = initValues.bedragAlBetaaldDureStudie || 0;
        const bedrag2 = initValues.bedragNogTeBestedenDureStudie || 0;
        this.studieBedragTeLaag = (bedrag1 + bedrag2) < 20000;
        this.vrijstellingenFg.valueChanges.subscribe(values => {
            const bedrag1 = values.bedragAlBetaaldDureStudie || 0;
            const bedrag2 = values.bedragNogTeBestedenDureStudie || 0;
            this.studieBedragTeLaag = (bedrag1 + bedrag2) < 20000;
        });
        this.isKindEnJongerDan40Result = this.isKindEnJongerDan40(this.sbAangifte);
    }

    ngOnDestroy(): void {
        if (this.sbBerekeningSubscription) {
            this.sbBerekeningSubscription.unsubscribe()
        }
        if (this.giftTaxEntitySubscription) {
            this.giftTaxEntitySubscription.unsubscribe()
        }
    }

    saveForm(): void {
        this.vrijstellingenFg.updateValueAndValidity({ emitEvent: false });
        this.schenkingFg.updateValueAndValidity({ emitEvent: false });
        const schenking = this.schenkingFg.value;
        schenking.vrijstellingen = {
            eenmaligVerhoogdeVrijstelling: this.vrijstellingenFg.getRawValue().eenmaligVerhoogdeVrijstelling,
            eenmaligVerhoogdeVrijstellingEigenWoning: this.vrijstellingenFg.getRawValue().eenmaligVerhoogdeVrijstellingEigenWoning,
            bedragAlBetaaldEigenWoning: this.vrijstellingenFg.getRawValue().bedragAlBetaaldEigenWoning,
            bedragNogTeBestedenEigenWoning: this.vrijstellingenFg.getRawValue().bedragNogTeBestedenEigenWoning,
            verhoogdeVrijstellingStudie: this.vrijstellingenFg.getRawValue().verhoogdeVrijstellingStudie,
            bedragAlBetaaldDureStudie: this.vrijstellingenFg.getRawValue().bedragAlBetaaldDureStudie,
            bedragNogTeBestedenDureStudie: this.vrijstellingenFg.getRawValue().bedragNogTeBestedenDureStudie,
            vrijstellingSchuldenaar: this.vrijstellingenFg.getRawValue().vrijstellingSchuldenaar,
            vrijstellingNatuurlijkeVerbintenis: this.vrijstellingenFg.getRawValue().vrijstellingNatuurlijkeVerbintenis,
            vrijstellingAnbiOfSbbi: this.vrijstellingenFg.getRawValue().vrijstellingAnbiOfSbbi,
            vrijstellingSchenkingDoorKoning: this.vrijstellingenFg.getRawValue().vrijstellingSchenkingDoorKoning,
            vrijstellingSchenkingDoorStaat: this.vrijstellingenFg.getRawValue().vrijstellingSchenkingDoorStaat,
            vrijstellingSchenkingBelastInIB: this.vrijstellingenFg.getRawValue().vrijstellingSchenkingBelastInIB,
            vrijstellingSchenkingAanNabestaandeWerknemer: this.vrijstellingenFg.getRawValue().vrijstellingSchenkingAanNabestaandeWerknemer,
            vrijstellingOverig: this.vrijstellingenFg.getRawValue().vrijstellingOverig,
            alGebruikteBasisvrijstelling: this.vrijstellingenFg.getRawValue().alGebruikteBasisvrijstelling,
            alGebruikteEenmaligeVerhoogdeVrijstelling: this.vrijstellingenFg.getRawValue().alGebruikteEenmaligeVerhoogdeVrijstelling,
            alGebruikteVrijstellingDureStudie: this.vrijstellingenFg.getRawValue().alGebruikteVrijstellingDureStudie,
        }
        this.giftTaxEntity.aangifte = {
            ...this.sbAangifte,
            schenking: [schenking],
        } as AangifteSchenkbelasting;
        this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
        this.toepassenVerhoogdeVrijstelling();
        this.toepassenOverigeVrijstelling();
        setTimeout(() => {
            this.sbService.getCalculation();
        }, 500)
    }

    protected readonly SchenkingRelatieBegiftigdeMetSchenker = SchenkingRelatieBegiftigdeMetSchenker;

    private toepassenVerhoogdeVrijstelling() {
        if (this.sbBerekening.totaleVerhoogdeVrijstellingen != undefined) {
            this.verhoogdeVrijstellingToegepast = true
            this.recalculateBerekeningVerhoogd();
        }
    }

    private toepassenOverigeVrijstelling() {
        if (this.vrijstellingenFg.getRawValue().verhoogdeVrijstellingStudie ||
            this.vrijstellingenFg.getRawValue().vrijstellingSchuldenaar ||
            this.vrijstellingenFg.getRawValue().vrijstellingNatuurlijkeVerbintenis ||
            this.vrijstellingenFg.getRawValue().vrijstellingAnbiOfSbbi ||
            this.vrijstellingenFg.getRawValue().vrijstellingSchenkingDoorKoning ||
            this.vrijstellingenFg.getRawValue().vrijstellingSchenkingDoorStaat ||
            this.vrijstellingenFg.getRawValue().vrijstellingSchenkingBelastInIB ||
            this.vrijstellingenFg.getRawValue().vrijstellingSchenkingAanNabestaandeWerknemer
        ) {
            this.overigeVrijstellingToegepast = true
            this.recalculateBerekeningOverig();
        }
    }

    public isKindEnJongerDan40(sbAangifte: any): boolean {
        const begiftigde = sbAangifte.begiftigde;
        const schenking = sbAangifte.schenking[0];
        if (schenking.relatieBegiftigdeMetSchenker !== "KIND") {
            return false;
        }
        const geboortedatum = new Date(begiftigde.geboortedatum);
        const datumSchenking = new Date(schenking.datumSchenking);
        const veertigsteVerjaardag = new Date(geboortedatum);
        veertigsteVerjaardag.setFullYear(veertigsteVerjaardag.getFullYear() + 40);
        return datumSchenking <= veertigsteVerjaardag;
    }

    private recalculateBerekeningVerhoogd(): void {
        const verhoogd = this.vrijstellingenFg.get('eenmaligVerhoogdeVrijstelling')?.value;
        const nieuweWaarde = verhoogd ? 0 : this.sbBerekeningFg.get('totaleBasisVrijstellingen')?.getRawValue();
        this.sbBerekeningFg.patchValue({
            totaleBasisVrijstellingen: nieuweWaarde,
        }, { emitEvent: false });
        this.verhoogdeVrijstellingToegepast = verhoogd;
    }
    private recalculateBerekeningOverig(): void {
        const veldenOmTeVolgen = [
            'eenmaligVerhoogdeVrijstelling',
            'verhoogdeVrijstellingStudie',
            'vrijstellingSchuldenaar',
            'vrijstellingNatuurlijkeVerbintenis',
            'vrijstellingAnbiOfSbbi',
            'vrijstellingSchenkingDoorKoning',
            'vrijstellingSchenkingDoorStaat',
            'vrijstellingSchenkingBelastInIB',
            'vrijstellingSchenkingAanNabestaandeWerknemer',
            'vrijstellingOverig'
        ];
        const waarden = veldenOmTeVolgen.map(veld =>
            this.vrijstellingenFg.get(veld)?.value
        );
        const verhoogd = waarden.some(waarde => waarde === true || waarde === 'Ja');
        const nieuweWaarde = verhoogd ? 0 : this.sbBerekeningFg.get('totaleBasisVrijstellingen')?.getRawValue();
        this.sbBerekeningFg.patchValue({
            totaleBasisVrijstellingen: nieuweWaarde,
        }, { emitEvent: false });
        this.verhoogdeVrijstellingToegepast = verhoogd;
    }

}
